if (typeof AI == "undefined") { AI = {}; }

(function (AI) {
    'use strict';

    var videoHelper = function () {
        this.videoHelper = {};
    };

    videoHelper.prototype = {

        init: function () {
            $('#videoModal').on('hidden.bs.modal', function () {
                var $frame = $('.videoWrapper iframe');
                var vidsrc = $frame.attr('src'); // sets the source to nothing, stopping the video

                $frame.attr('src', ''); // sets it back to the correct link so that it reloads immediately on the next window open

                $frame.attr('src', vidsrc);
            });
        }
    };

    AI.videoHelper = new videoHelper();

})(AI);

AI.videoHelper.init();



// WEBPACK FOOTER //
// ./resources/assets/js/ai/video.js